import { normalizeOtherBroker } from "./otherBroker";

/**
 * 将 direct_list 单条第三方账户（userType 5）规范为表格行。
 *
 * @param {Record<string, unknown>} raw
 * @returns {Record<string, unknown>}
 */
export function normalizeThirdPartyListRow(raw) {
  const other =
    normalizeOtherBroker(raw.otherBroker) ||
    (raw.otherBroker &&
    typeof raw.otherBroker === "object" &&
    !Array.isArray(raw.otherBroker)
      ? raw.otherBroker
      : null);
  const brokerName =
    other && other.brokerName != null && String(other.brokerName).trim() !== ""
      ? String(other.brokerName).trim()
      : "";
  const smId =
    other && other.brokerId != null && other.brokerId !== ""
      ? String(other.brokerId)
      : "";
  const listBrokerId = smId;
  const marketOn =
    raw.market === true ||
    raw.market === 1 ||
    String(raw.market) === "1" ||
    raw.isMarket === true ||
    raw.isMarket === 1 ||
    String(raw.isMarket) === "1";
  const visibleRaw = raw.visible;
  const visibleOn = !(
    visibleRaw === false ||
    visibleRaw === 0 ||
    String(visibleRaw) === "0"
  );
  return {
    ...raw,
    brokerName,
    listBrokerId,
    serverManageName: brokerName,
    ServerManageId: smId,
    userType: 5,
    userTypeName: "第三方账户",
    otherBroker: other,
    market: marketOn,
    visible: visibleOn,
    sort: raw.sort != null ? raw.sort : 0,
  };
}



// WEBPACK FOOTER //
// ./src/view/user/eval_jees/third_party/normalizeThirdPartyListRow.js